import { Box, Typography } from '@mui/material';

export const FormattedToastMessage = ({
  title,
  message,
}: {
  title: string;
  message: string;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
        gap: 1,
        flex: 1,
      }}
    >
      <Typography sx={{ fontSize: 16, fontWeight: 700 }}>{title}</Typography>
      <Typography sx={{ fontSize: 14 }}>{message}</Typography>
    </Box>
  );
};
